import { QbsTable } from 'qbs-react-grid'
import React, { useEffect, useState } from 'react'

import { TableColumns } from '../../../common/types'
import Icons from '../../../components/common/icons'
import { calcWindowHeight } from '../../../utilities/calcHeight'
import { handleReturnEmptyMsg } from '../../../utilities/validation'
import { getOrgDataTableUpdateReport } from '../api'
import { getColumns } from './columns'

export default function OrganisationDataTableUpdateReport({
  searchParams,
  pageParams,
  onChangePage,
  onChangeRowsPerPage,
  handleSeach,
}: any) {
  const [columns, setColumns] = useState<TableColumns[]>([])
  const [data, setData] = useState<any>([])

  const onViewAction = () => {
    console.log('onview')
  }

  useEffect(() => {
    setColumns(
      getColumns({
        onViewAction: onViewAction,
      })
    )
  }, [])
  const getData = async () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { filters, filterProps, ...restSearchParams } = pageParams
    const data = await getOrgDataTableUpdateReport({
      ...searchParams,
      ...restSearchParams,
    })
    setData(data)
  }
  useEffect(() => {
    getData()
  }, [searchParams, pageParams])

  return (
    <div className=" p-4">
      <QbsTable
        data={data?.items ?? []}
        dataRowKey="id"
        toolbar={true}
        height={
          data?.length === 0 ? calcWindowHeight(218) : calcWindowHeight(335)
        }
        // isLoading={isFetching}
        // sortType={pageParams.sortType}
        // sortColumn={pageParams.sortColumn}
        // handleColumnSort={handleSort}
        emptyTitle="No records to display"
        emptySubTitle={handleReturnEmptyMsg(pageParams?.search)}
        columns={columns}
        pagination={true}
        renderSortIcon={(sortType?: 'asc' | 'desc' | undefined) => {
          return sortType === 'asc' ? (
            <Icons name="ascending-icon" />
          ) : sortType === 'desc' ? (
            <Icons name="descending-icon" />
          ) : (
            <Icons name="qbs-sort-icon" />
          )
        }}
        paginationProps={{
          onPagination: onChangePage,
          total: data?.total,
          currentPage: pageParams?.page,
          rowsPerPage: Number(pageParams?.page_size ?? data?.page_size),
          onRowsPerPage: onChangeRowsPerPage,
          dropOptions: [10, 20, 30, 50, 100],
        }}
        searchValue={pageParams?.search}
        onSearch={handleSeach}
        asyncSearch
        // handleSearchValue={(key?: string) => handleSeach(key)}
        columnToggle
      />
    </div>
  )
}
